import { request } from './client';
import type { InvitationItem, InviteResult, MeResponse } from '@kassa/shared';

// Mühasib dəvəti (KT-63).
export const invitationsApi = {
  invite: (identifier: string) => request<InviteResult>('POST', '/api/invitations', { identifier }),
  myInvitations: () => request<InvitationItem[]>('GET', '/api/invitations/mine'),
  acceptInvitation: (id: string) =>
    request<{ result: string; me: MeResponse | null }>('POST', `/api/invitations/${encodeURIComponent(id)}/accept`),
  rejectInvitation: (id: string) =>
    request<{ result: string; me: MeResponse | null }>('POST', `/api/invitations/${encodeURIComponent(id)}/reject`),
};
